import { isNil } from 'lodash';

const apiPrefix = (accountName, reportId) => `/${accountName}/dynamic-reports${isNil(reportId) ? '' : `/${reportId}`}`;
const apiMetaModelPrefix = (accountName, metaModelType) => `${apiPrefix(accountName)}/metamodel/${metaModelType}`;

export const dynamicReportApiFactory = ({ callPostApi, callGetApi, callPutApi, callDeleteApi }) => ({
    createReport: (accountName, reportObject) => callPostApi(apiPrefix(accountName), reportObject),
    getReport: (accountName, reportId) => callGetApi(apiPrefix(accountName, reportId)),
    updateReport: (accountName, reportId, reportObject) => callPutApi(apiPrefix(accountName, reportId), reportObject),
    deleteReport: (accountName, reportId) => callDeleteApi(apiPrefix(accountName, reportId)),
    getMetaModel: (accountName, metaModelType) => callGetApi(apiMetaModelPrefix(accountName, metaModelType)),
});
